import React from "react"
import { useTranslation } from "react-i18next"
import {
  withFormik,
  FormikProps,
  Form,
  FormikHelpers as FormikActions,
} from "formik"
import { Typography } from "@mui/material"

import { Card, Headline, Submit } from "components/Sessions/elements"
import PollingService from "redux/api/pollingService"
import { ClientIdCardFormValues } from "types"

interface FormProps {
  initialValues: ClientIdCardFormValues
  onSubmit: (
    values: ClientIdCardFormValues,
    actions: FormikActions<object>,
  ) => void
}

type Props = FormikProps<ClientIdCardFormValues> & FormProps

const IdCardForm = ({ values, isSubmitting }: Props) => {
  const { t } = useTranslation()

  const isPolling = PollingService.isPolling()

  const { terms } = values
  const isDisabled = isSubmitting || isPolling || terms === false

  return (
    <Form>
      <Card elevation={0}>
        <Headline>{t("providers.id_card.title")}</Headline>
        <Typography
          dangerouslySetInnerHTML={{ __html: t("providers.id_card.text") }}
        />
      </Card>
      <Submit type="submit" disabled={isDisabled}>
        {t("pages.sessions.form.submit")}
      </Submit>
    </Form>
  )
}

const IdCardFormWithFormik = withFormik<FormProps, ClientIdCardFormValues>({
  enableReinitialize: true,
  handleSubmit: (values, actions) => actions.props.onSubmit(values, actions),
})(IdCardForm)

export default IdCardFormWithFormik
